module.exports = __webpack_public_path__ + "static/media/parking-circle.9a2d0493.svg";